<div class="flex items-center justify-between">
    <h2 mat-dialog-title class="text-xl font-semibold m-0">{{ 'unitSelection.title' | transloco }}</h2>
    <button mat-icon-button mat-dialog-close class="-mr-2">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="min-w-[400px]">
    <p class="text-secondary mb-4">{{ 'unitSelection.description' | transloco }}</p>

    <mat-form-field class="w-full" appearance="fill">
        <mat-label>{{ 'unitSelection.label' | transloco }}</mat-label>
        <mat-select [formControl]="unitControl" multiple>
            <mat-option *ngFor="let unit of units" [value]="unit.id">
                {{ unit.code }} - {{ unit.name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="unitControl.hasError('required')">
            {{ 'unitSelection.required' | transloco }}
        </mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [disabled]="unitControl.invalid || saving" (click)="save()">
        {{ 'unitSelection.save' | transloco }}
    </button>
</mat-dialog-actions>
